import React from "react";
import Orderdetails from "../Components/OrderDetails/Orderdetails";
import Breadcrumb from "../Components/Breadcrumb";
import SpecialProducts from "../Components/Productdetails/SpecialProducts";
import { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
function Orderdetailspage() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

     useEffect(() => {
          AOS.init({
            once: false,
          });
      
          const handleScroll = () => {
            AOS.refresh();
          };
      
          window.addEventListener("scroll", handleScroll);
      
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, []);

  return (
    <>
      <Breadcrumb list1="Your Account" list2="Orders" list3="Track Order" />
      <Orderdetails />
      <SpecialProducts />
    </>
  );
}

export default Orderdetailspage;
